// Filename: uilink.js
// Timestamp: 2018.12.09-00:27:43 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gnenumXONCLICK as XONCLICK
} from '../gnenum.js'

import {
  gndom_nodeelemclasstoggle
} from '../gndom.js'

const isactive = ({ activevalue, value }) => (
  typeof activevalue !== 'undefined' && activevalue === value)

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const a = cfg.h(ndx, nd).a
  const href = subj.href
  const label = subj.label
  const target = subj.target
  const title = subj.title || label

  ndx.childVNodesGet(ss, cfg, gr, nd)

  return (
    a(`.:ui.st-isactive-${isactive(subj)}#:key`, {
      href,
      title,
      target
    }, [
      // render label or, if present, child
      typeof label === 'string'
        ? label
        : ndx.childVNodesGet(ss, cfg, gr, nd)
    ])
  )
}

const xonclick = (ss, cfg, gr, nd, ndx, prev, subj, ev) => {
  if (nd.has(XONCLICK.slice(1))) {
    ev.preventDefault()
    ndx.publishev(ss, cfg, nd, XONCLICK)
  }
}

const xonsubj = (ss, cfg, gr, nd, ndx, prev, subj) => {
  if (subj.activevalue !== prev.activevalue) {
    gndom_nodeelemclasstoggle(cfg, nd, 'st-isactive', isactive(subj))
  }

  return true
}

export default {
  type: 'uilink',
  xvnode,
  xonclick,
  xonsubj
}
